import * as moment from 'moment';
import { DistributionStatus } from '../../domain/enums/distribution-status';
import { SectorOverviewItem } from '../../domain/models';
import { Device } from '../../domain/models/distribution/device';
import { Distribution } from '../../domain/models/distribution/distribution';
import { DistributionAddress } from '../../domain/models/distribution/distribution-address';
import { DistributionStreet } from '../../domain/models/distribution/street';
import { TotalWorkTime } from '../../domain/models/distribution/total-work-time';
import { DeviceViewModel } from './device.view-model';

export class DistributionViewModel {
    public id: string;
    public technicalCycleId: string;
    public noteId: string;
    public sectorId: string;
    public bdSectorId: string;
    public sectorName: string;
    public distributorName: string;
    public distributorType: string;
    public distributorPhoneNumber: string;
    public distributionProgress: number;
    public distributionProgressEarly: number;
    public distributionProgressLate: number;
    public totalWorkTime: Date;
    public devices: DeviceViewModel[];
    public status: DistributionStatus;
    public statusText: string;
    public latestUpdate: Date;
    public plannedStartDate: Date;
    public plannedEndDate: Date;
    public cycleStart: Date;
    public cycleEnd: Date;
    public addresses: DistributionAddress[];
    public streets: DistributionStreet[];

    constructor();
    constructor(json: any, sector: SectorOverviewItem, statusText: string)
    constructor(json?: Distribution, sector?: SectorOverviewItem, statusText?: string) {
        if (json) {
            this.id = json.id;
            this.technicalCycleId = json.cycle ? json.cycle.technicalCycleId : '';
            this.noteId = json.noteId;
            this.sectorId = sector ? sector.id : '';
            this.bdSectorId = sector ? sector.bdSectorId : '';
            this.sectorName = sector ? sector.name : '';
            this.distributorName = json.distributor ? json.distributor.name : '';
            this.distributorPhoneNumber = json.distributor ? json.distributor.phoneNumber : '';
            this.devices = json.devices.map((device: Device) => new DeviceViewModel(device));
            this.totalWorkTime = this.getTotalWorkTime(json.totalWorkTime);
            this.distributionProgress = json.percentageComplete;
            this.distributionProgressEarly = json.percentageCompleteEarly;
            this.distributionProgressLate = json.percentageCompleteLate;
            this.status = json.status;
            this.statusText = statusText ? statusText : '';
            this.latestUpdate = json.lastProcessing ? new Date(json.lastProcessing) : null;
            this.plannedStartDate = json.plannedStartDate ? new Date(json.plannedStartDate) : null;
            this.plannedEndDate = json.plannedEndDate ? new Date(json.plannedEndDate) : null;
            this.streets = json.streets;
            this.addresses = json.addresses;
        }
    }

    getTotalWorkTime(totalWorkTime: TotalWorkTime): Date {

        let workTime: moment.Moment = totalWorkTime
            ? moment(new Date(2018, 1, 1, totalWorkTime.hours, totalWorkTime.minutes, totalWorkTime.seconds, totalWorkTime.milliseconds))
            : moment(new Date(2018, 1, 1, 0, 0, 0, 0));
        return workTime.toDate();
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/view-models/distribution.view-model.ts